/**
 * Versão do build atualmente em execução, injetada em tempo de compilação
 * (ver `vite.config.mts`). Comparada com `/version.json` para detectar deploys novos.
 */
export const APP_VERSION = __APP_VERSION__;

/**
 * Lê a versão publicada no servidor a partir de `/version.json` (sempre sem cache).
 * Retorna `null` quando o arquivo não existe (ex.: ambiente de dev) ou em qualquer erro,
 * para o chamador simplesmente não fazer nada nesses casos.
 */
export async function fetchServerVersion(signal?: AbortSignal): Promise<string | null> {
	try {
		const resposta = await fetch("/version.json", { cache: "no-store", signal });
		if (!resposta.ok) return null;

		const dados = (await resposta.json()) as { version?: unknown };
		return typeof dados.version === "string" ? dados.version : null;
	} catch {
		return null;
	}
}
